import { createColumnHelper } from '@tanstack/react-table';
import { ProductApproval } from '@texas/api/endpoints/productApprovalsApi';
import { productApprovalColumns } from '@texas/components/article/productApproval/Columns';
import { TFunction } from 'i18next';

export function customerProductApprovalColumns(
  isDarkMode: boolean,
  t: TFunction,
  onStateChange: (id?: number) => void,
) {
  const columnHelper = createColumnHelper<ProductApproval>();

  return [
    columnHelper.accessor('articleItemCode', {
      cell: (info) => info.getValue(),
      header: t('general.itemCode'),
      enableSorting: true,
      meta: { toggleable: true, defaultVisible: true },
    }),
    ...productApprovalColumns(isDarkMode, t, onStateChange),
  ];
}
